import * as cx from 'classnames';
import { Picker } from 'mk/forms/Picker';
import { Context } from 'mk/interfaces';
import Emoji from 'mk2/components/Emoji';
import { supportsEmoji } from 'mk2/helpers/detects';
import { toShort } from 'mk2/helpers/emojis';
import * as React from 'react';
import { findDOMNode } from 'react-dom';

const EMOJI_SETS = {
    PEOPLE: [
        '🙂', '😉', '☹️', '😒', '😠', '😎', '😖', '😲', '😢', '😀', '😝', '😔', '😅', '😕',
        '🙄', '😨', '🤐', '😵', '😂', '😍', '😘', '😇', '🤒', '😴', '😈', '👽', '❤️', '👏',
        '👍', '👎', '🙏', '👶', '👦', '👧', '💃', '🤰',
    ],
    NATURE: [
        '🐶', '🐱', '🐭', '🐻', '🐷', '🐙', '🐧', '🐝', '🐘', '🙈', '🙉', '🙊', '🌳', '🌴',
        '🍀', '🍂', '🌹', '🌷', '☃️', '🌜', '🌞', '🌧', '🔥', '❄️', '🍏', '🍉', '🍒', '🥕',
        '🥑', '🍕', '🍣', '🥗', '🎂', '🍼', '☕', '🍹',
    ],
    WORLD: [
        '🚗', '🚕', '🚌', '🚓', '🚑', '🚒', '🏍', '🚲', '🚂', '⛵', '✈️', '🚀', '⛰', '🏕',
        '🏖', '🏙', '🏡', '📱', '💻', '📷', '💵', '💎', '🔨', '💣', '💉', '💊', '🔑', '🎈',
        '🎁', '🎉', '📨', '📦', '📓', '🛒', '🇸🇰', '🇨🇿',
    ],
};

interface OwnProps {
    className?: string;
    context: Context;

    onSelect(emoji: string);
}

interface State {
    opened: boolean;
}

export class EmojiPicker extends React.Component<OwnProps, State> {

    constructor(props, context) {
        super(props, context);

        this.state = {
            opened: false,
        };
    }

    public render() {
        const {opened} = this.state;
        return (
            <div className={cx('emoji-picker', this.props.className)}>
                <div className="g-form-emoji-picker form-action-button">
                    <Picker
                        sets={EMOJI_SETS}
                        getItem={this.getPickerItem}
                        onSelect={this.onSelect}
                        opened={opened}
                    />
                    <div className={cx('emoji', 'trigger', opened ? 'selected' : '')} onClick={this.toggle}>
                        <Emoji
                            emoji={'🙂'}
                            size={20}
                            force
                        />
                    </div>
                </div>
            </div>
        );
    }

    private documentClickHandler = (e) => {
        const domNode = findDOMNode(this);
        if (domNode instanceof Element && !domNode.contains(e.target)) {
            this.close();
        }
    };

    private open = () => {
        window.addEventListener('click', this.documentClickHandler);
        this.setState({opened: true});
    };

    private close = () => {
        window.removeEventListener('click', this.documentClickHandler);
        this.setState({opened: false});
    };

    private toggle = () => {
        this.state.opened ? this.close() : this.open();
    };

    private onSelect = (emoji) => {
        this.close();
        if (this.props.onSelect) { this.props.onSelect(supportsEmoji() ? emoji : toShort(emoji)); }
    };

    private getPickerItem = (emoji) => {
        return (
            <div className="emoji">
                <Emoji
                    emoji={emoji}
                    size={20}
                />
            </div>
        );
    };

}
